import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ComparingDateInfo = (
  { selectedComparingYear, selectedComparingMonth },
) => (
  <div className="c-comparing-date-info">
    {
      selectedComparingYear && selectedComparingMonth && (
      <Fragment>
        {`${selectedComparingMonth.label} ${selectedComparingYear.label}`}
        <br />
      </Fragment>
      )
    }
  </div>
);

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

ComparingDateInfo.propTypes = {
  selectedComparingYear: optionPropType,
  selectedComparingMonth: optionPropType,
};

ComparingDateInfo.defaultProps = {
  selectedComparingYear: null,
  selectedComparingMonth: null,
};

export default ComparingDateInfo;



// WEBPACK FOOTER //
// ./src/components/emissions-demo/components/comparing-date-info/component.js